import React from "react";
import tw from "twin.macro";

const VideoOverlay = ({ videoId, onClose }) => {
  return (
    <div css={tw`fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50`}>
      <div css={tw`relative bg-transparent p-4 md:p-20 rounded-lg max-w-[1248px] w-full md:w-4/5 block`}>
        <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
          <iframe
            src={`https://player.vimeo.com/video/${videoId}?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479`}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
            style={{ position: "absolute", top: "0", left: "0", width: "100%", height: "100%" }}
            title="PP-AUV-US-2400137 Auvelity Patient Ambassador Video- Mecca"
          ></iframe>
        </div>
        <button
          css={tw`absolute top-[-30px] right-[20px] md:top-[50px] text-white`}
          onClick={onClose}
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default VideoOverlay;